import { Box } from "@mui/material";
import WorkoutDayCard from "./WorkoutDayCard";
import AddNewDayCard from "./AddNewDayCard";

const WorkoutDaysSection = ({
    numberOfDays,
    exercisesByDay,
    workouts,
    onDeleteDay,
    onAddNewDay,
    onRemoveExerciseFromDay,
    onExerciseUpdate,
    onReorderExercises,
    onAddExercises,
    onAddSuperSet,
    onDuplicateDay,
    onPresentDay,
    isSuperAdmin,
    isSystemResource,
    readOnly,
    onWorkoutNameUpdate,
}) => {
    return (
        <Box sx={{
            flex: 1,
            padding: 3,
            direction: 'rtl',
            overflowY: 'auto',
            overflowX: 'hidden',
        }}>
            <Box sx={{
                display: 'grid',
                gap: 2.5,
                maxWidth: '100%',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    lg: 'repeat(3, 1fr)',
                }
            }}>
                {Array.from({ length: numberOfDays }, (_, index) => {
                    const dayNumber = index;
                    const dayExercises = exercisesByDay[dayNumber] || [];
                    const workout = workouts?.find(w => w.index === dayNumber);

                    return (
                        <WorkoutDayCard
                            key={dayNumber}
                            dayNumber={dayNumber}
                            dayExercises={dayExercises}
                            numberOfDays={numberOfDays}
                            readOnly={readOnly}
                            onDeleteDay={onDeleteDay}
                            onRemoveExerciseFromDay={onRemoveExerciseFromDay}
                            onExerciseUpdate={onExerciseUpdate}
                            onReorderExercises={onReorderExercises}
                            onAddExercises={onAddExercises}
                            onAddSuperSet={onAddSuperSet}
                            onDuplicateDay={onDuplicateDay}
                            onPresentDay={onPresentDay}
                            workoutName={workout?.name}
                            workoutNameHeb={workout?.nameHeb}
                            // null for a day added but not yet saved (addNewDay seeds id: null) —
                            // the translation panel needs a real row to write against.
                            workoutId={workout?.id ?? null}
                            onWorkoutNameUpdate={onWorkoutNameUpdate}
                        />
                    );
                })}

                {!readOnly && numberOfDays < 7 && (!isSystemResource || (isSystemResource && isSuperAdmin())) && (
                    <AddNewDayCard
                        numberOfDays={numberOfDays}
                        onAddNewDay={onAddNewDay}
                    />
                )}
            </Box>
        </Box>
    );
};

export default WorkoutDaysSection;
